import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Waveform } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const nav = useNavigate();
  const { setUserAndToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    const desiredRole = sessionStorage.getItem("xookmedia_google_role") || "fan";
    sessionStorage.removeItem("xookmedia_google_role");
    api.post("/auth/google", { session_id, role: desiredRole })
      .then((r) => {
        localStorage.setItem("xookmedia_token", r.data.token);
        setUserAndToken(r.data.user);
        const target = r.data.user.role === "admin" ? "/admin" : r.data.user.role === "artist" ? "/dashboard" : "/concerts";
        // clean hash
        window.history.replaceState({}, "", "/");
        nav(target, { replace: true });
      })
      .catch(() => {
        nav("/login?error=google");
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col items-center justify-center gap-4">
      <Waveform weight="fill" size={48} className="text-[#E11D48] animate-pulse" />
      <p className="text-zinc-400">Connexion via Google...</p>
    </div>
  );
};

export default AuthCallback;
